import React from "react";

export default function BrazilianCarnivalFrame5({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-5br1{fill:#f4c916}.cls-5br2{fill:#2fbc93}.cls-5br3{fill:#f40bb8}.cls-5br4{fill:#8100a0}"
            }
          </style>
        </defs>
        <path
          d="M1759.38 1946.65H240.62V53.35h1518.75v1893.31ZM287.6 1899.68h1424.81V100.31H287.59v1799.37Z"
          className="cls-5br1"
        />
        <path
          d="M333.21 264.6 305.83 94.31a490.295 490.295 0 0 0 66.71 26.66 490.766 490.766 0 0 0 78.86 18.01c-39.4 41.87-78.79 83.74-118.19 125.62Z"
          className="cls-5br3"
        />
        <path
          d="m474.07 234.97-28.44-96.35a300.44 300.44 0 0 0 41.22 10.99 299.77 299.77 0 0 0 47.76 5.2c-20.18 26.72-40.36 53.45-60.54 80.17Z"
          className="cls-5br2"
        />
        <path
          d="m733.22 241.14-53.23-85.2c12.42.75 26.78.84 42.66-.47 18.11-1.5 34.06-4.48 47.4-7.8-12.28 31.16-24.55 62.31-36.83 93.47Z"
          className="cls-5br1"
        />
        <path
          d="m988.34 181.18-75.73-66.01a297.71 297.71 0 0 0 40.68-12.87c16.89-6.71 31.28-14.2 43.08-21.26-2.68 33.38-5.35 66.76-8.03 100.14ZM608.76 307.9l-76.14-154.76a491.09 491.09 0 0 0 71.59 5.92c30.6.28 57.79-2.33 80.68-5.92-25.38 51.59-50.76 103.17-76.14 154.76Z"
          className="cls-5br4"
        />
        <path
          d="M876.24 281.06 766.47 148.03c20.89-1.61 44.87-4.8 71.03-10.75a490.12 490.12 0 0 0 77.14-24.37c-12.8 56.05-25.6 112.1-38.39 168.15Z"
          className="cls-5br2"
        />
        <path
          d="m1656.01 274.32 33.15-169.26a490.356 490.356 0 0 1-67.57 24.38 491.308 491.308 0 0 1-79.43 15.32c37.95 43.19 75.9 86.37 113.85 129.56Z"
          className="cls-5br3"
        />
        <path
          d="m1519.73 240.36 28.58-96.31a297.068 297.068 0 0 1-41.24 10.92 299.167 299.167 0 0 1-47.77 5.13c20.14 26.75 40.28 53.51 60.42 80.26Z"
          className="cls-5br2"
        />
        <path
          d="m1261.87 246.15 53.36-85.12c-12.42.73-26.78.8-42.66-.53a298.736 298.736 0 0 1-47.39-7.87c12.23 31.17 24.46 62.35 36.69 93.52Z"
          className="cls-5br1"
        />
        <path
          d="m1008.87 181.72 73.63-68.34a299.924 299.924 0 0 1-41.06-11.59 298.453 298.453 0 0 1-43.72-19.91c3.72 33.28 7.43 66.56 11.15 99.84ZM1386.73 313.09l76.36-154.65a490.982 490.982 0 0 1-71.6 5.82c-30.6.24-57.79-2.41-80.67-6.04 25.3 51.62 50.61 103.25 75.91 154.87Z"
          className="cls-5br4"
        />
        <path
          d="m1119.13 281.09 109.97-132.87c-22.16-3.93-45.31-8.62-69.32-14.25-27.85-6.52-54.14-13.65-78.8-21.09 12.72 56.07 25.43 112.14 38.15 168.2Z"
          className="cls-5br2"
        />
        <path
          d="M1378.32 166.52c-66.78 0-133.7-7.19-199.79-21.51-62-13.43-123.13-33.12-181.74-58.54-47.4 20.72-97.02 37.5-147.5 49.88-72.88 17.87-147.78 26.64-222.59 26.09-72.89-.54-145.76-9.95-216.6-27.97-50.04-12.73-99.22-29.8-146.16-50.75a4.312 4.312 0 0 1-2.18-5.7 4.312 4.312 0 0 1 5.7-2.18c112.26 50.09 236.5 77.05 359.31 77.97 125.73.93 253.07-25.34 368.28-75.99l1.73-.76 1.73.75c144.46 62.98 301.83 89.6 455.1 76.99 98.6-8.11 195.31-32.05 287.46-71.14 2.19-.93 4.73.09 5.66 2.29.93 2.19-.09 4.72-2.29 5.66-93 39.45-190.61 63.6-290.12 71.79a926.484 926.484 0 0 1-75.99 3.12Z"
          className="cls-5br1"
        />
        <path
          d="M1398.68 1772.14c-15.25 1.99-42.96 3.35-73.48-8.85-13.26-5.3-23.91-11.9-32.03-17.93a116.53 116.53 0 0 0 20.42 20.47c5.43 4.23 10.69 7.56 15.44 10.17-9.01-.63-23.39-2.73-39.34-10.2a110.877 110.877 0 0 1-33.27-23.97c4.3 8.63 12.81 22.66 28.46 34.38a94.43 94.43 0 0 0 21.19 11.93c-4.25.02-9.16-.31-14.54-1.33-13.01-2.49-22.83-7.94-29.03-12.17 3.05 3.79 7.12 8.04 12.44 12.01 1.89 1.41 3.75 2.65 5.54 3.73-4.42.14-9.48-.03-15.01-.82-12.91-1.86-23.07-6.35-29.95-10.17l47.72 42.08c1.25 1.1 17.08 15.07 18.34 16.18 32.37-21.83 64.73-43.67 97.1-65.5ZM1560.8 1717.92c13.11-8.04 35.51-24.41 51.57-53.08 6.98-12.46 11.11-24.29 13.63-34.08.15 7.8-.43 17.67-3 28.76-1.56 6.71-3.56 12.6-5.61 17.62 6.61-6.15 16.47-16.83 24.18-32.67a111.097 111.097 0 0 0 10.8-39.55c2.09 9.41 4.29 25.67-.52 44.63a94.328 94.328 0 0 1-8.98 22.61c3.32-2.65 6.93-6 10.47-10.18 8.56-10.12 12.76-20.53 14.92-27.71 0 4.87-.49 10.73-2.12 17.16-.58 2.29-1.25 4.41-1.96 6.38 3.53-2.67 7.35-5.98 11.15-10.08 8.87-9.56 13.95-19.44 16.89-26.75-1.75 10.33-8.89 52.4-10.64 62.72-.28 1.64-3.8 22.45-4.09 24.11-38.9 3.37-77.79 6.75-116.69 10.12Z"
          className="cls-5br3"
        />
        <path
          d="M1573.45 1704.55c-7.94 4.09-17.24 9.61-26.26 19.93-19.54 22.35-24.97 51.72-25.94 73.51-.15 2.72-1.31 16.12-11.11 22.2-8.45 5.25-19.92 2.91-29.08-5.95-7.19-8.32-16.58-17.61-27.95-25.47-11.37-7.86-24.71-14.3-39.79-16.93 0 0-15.67-2.52-32.95 1.02-44.96 9.18-74.95 58.34-78.77 64.78 2.69 3.29 55.56 66.13 117.1 56.4 11.88-1.88 35.16-5.56 54.52-22.97 15.32-13.78 17.28-26.34 34.51-32.77 11.69-4.37 24.43-5.55 36.22-2.77 27.95 6.59 43.04 1.58 57.51-2.94 15.05-4.7 24.73-12.94 31.44-18.66 40.26-34.28 44.21-95.53 44.79-107.3-10.09-4.4-59.8-24.95-104.22-2.06Zm-150.48 165.97c-35.95-.43-57.08-31.36-58.71-33.83 12.92-24.21 37.26-37.93 62.86-35.3 32.07 3.3 50.55 30.66 52.88 34.22-1 1.91-19.36 35.37-57.03 34.91Zm178.69-63.41c-29.01 24.03-64.32 9.56-66.3 8.71-.43-4.23-3.27-37.12 19.6-59.86 18.25-18.15 45.8-22.78 71.07-12.08.29 2.95 3.3 40.29-24.37 63.22Z"
          className="cls-5br2"
        />
        <rect
          width={12.95}
          height={208.99}
          x={1686.21}
          y={1731.23}
          className="cls-5br2"
          rx={6.48}
          ry={6.48}
          transform="rotate(-19.48 1692.7 1835.755)"
        />
        <path
          d="M1417.46 1783.58c-38.41-3.94-74.92 16.64-94.3 52.95 2.45 3.71 34.15 50.11 88.07 50.76 56.5.68 84.05-49.52 85.55-52.37-3.49-5.35-31.2-46.39-79.32-51.34Zm5.51 86.94c-35.95-.43-57.08-31.36-58.71-33.83 12.92-24.21 37.26-37.93 62.86-35.3 32.07 3.3 50.55 30.66 52.88 34.22-1 1.91-19.36 35.37-57.03 34.91ZM1551.33 1736.22c-34.3 34.11-30.05 83.45-29.4 89.8 2.96 1.27 55.94 22.99 99.44-13.07 41.53-34.41 37-90.42 36.57-94.85-37.9-16.05-79.23-9.1-106.61 18.12Zm50.32 70.89c-29.01 24.03-64.32 9.56-66.3 8.71-.43-4.23-3.27-37.12 19.6-59.86 18.25-18.15 45.8-22.78 71.07-12.08.29 2.95 3.3 40.29-24.37 63.22Z"
          className="cls-5br3"
        />
        <path
          d="M1481.91 1816.67c8.56 7.17 19.72 8.6 28.28 3.67 10.41-5.99 11.9-18.45 12.05-19.92 7.46 10.58 14.91 21.17 22.37 31.75-7-1.31-21.69-2.98-37.69 3.84-9.6 4.09-16.38 9.83-20.64 14.16-1.45-11.17-2.91-22.34-4.36-33.51Z"
          className="cls-5br3"
        />
        <path
          d="M417.31 330.1c2 3.17 11.24 18.54 6.59 37.51-2.33 9.48-7.2 16.1-10.33 19.68-11.66-3.94-23.32-7.89-34.98-11.83 2.77-4.37 6.07-10.77 7.89-19 3.96-17.86-1.62-32.53-4.14-38.18 11.66 3.94 23.32 7.89 34.98 11.83Z"
          className="cls-5br4"
        />
        <path
          d="M536.56 248.41c1.4 2.56 7.86 15.04 5.14 33.09a61.54 61.54 0 0 1-6.49 19.64c-7.85-1.67-15.69-3.33-23.54-5a79.915 79.915 0 0 0 4.88-18.62c2.28-16.93-1.73-29.37-3.52-34.11 7.85 1.67 15.69 3.33 23.54 5Z"
          className="cls-5br3"
        />
        <path
          d="M1571.05 243.87c.81 1.47 4.53 8.67 2.96 19.08a35.56 35.56 0 0 1-3.74 11.33l-13.57-2.88c1.01-2.56 2.21-6.24 2.81-10.74 1.31-9.76-1-16.94-2.03-19.67l13.57 2.88Z"
          className="cls-5br4"
        />
        <path
          d="M1076.29 210.76c1.49 2.74 8.41 16.1 5.5 35.43a65.897 65.897 0 0 1-6.95 21.03c-8.4-1.78-16.8-3.57-25.2-5.35a85.433 85.433 0 0 0 5.22-19.94c2.44-18.13-1.85-31.44-3.77-36.52 8.4 1.78 16.8 3.57 25.2 5.35Z"
          className="cls-5br3"
        />
        <path
          d="M1239.47 312.99c1.49 2.74 8.41 16.1 5.5 35.43a65.897 65.897 0 0 1-6.95 21.03c-8.4-1.78-16.8-3.57-25.2-5.35a85.433 85.433 0 0 0 5.22-19.94c2.44-18.13-1.85-31.44-3.77-36.52 8.4 1.78 16.8 3.57 25.2 5.35Z"
          className="cls-5br2"
        />
        <path
          d="M1459.18 285.01c.94 1.73 5.31 10.17 3.47 22.37-.92 6.1-3.03 10.72-4.39 13.28-5.3-1.13-10.61-2.25-15.91-3.38 1.19-3 2.59-7.31 3.3-12.59 1.54-11.45-1.17-19.86-2.38-23.06 5.3 1.13 10.61 2.25 15.91 3.38Z"
          className="cls-5br3"
        />
        <path
          d="M1668.76 317.29c1.17 2.15 6.61 12.64 4.32 27.81a51.694 51.694 0 0 1-5.45 16.51l-19.78-4.2c1.48-3.73 3.22-9.09 4.1-15.65 1.92-14.23-1.46-24.69-2.96-28.67l19.78 4.2Z"
          className="cls-5br2"
        />
        <path
          d="M808.15 261.56c1.1 2.01 6.17 11.81 4.03 25.98a48.075 48.075 0 0 1-5.1 15.42c-6.16-1.31-12.32-2.61-18.48-3.92 1.38-3.48 3-8.49 3.83-14.62 1.79-13.29-1.36-23.06-2.77-26.78 6.16 1.31 12.32 2.61 18.48 3.92ZM957.37 299.53c1.1 2.01 6.17 11.81 4.03 25.98a48.075 48.075 0 0 1-5.1 15.42c-6.16-1.31-12.32-2.61-18.48-3.92 1.38-3.48 3-8.49 3.83-14.62 1.79-13.29-1.36-23.06-2.77-26.78 6.16 1.31 12.32 2.61 18.48 3.92Z"
          className="cls-5br4"
        />
        <path
          d="M704.43 356.7c1.1 2.01 6.17 11.81 4.03 25.98a48.075 48.075 0 0 1-5.1 15.42l-18.48-3.92c1.38-3.48 3-8.49 3.83-14.62 1.79-13.29-1.36-23.06-2.77-26.78 6.16 1.31 12.32 2.61 18.48 3.92Z"
          className="cls-5br2"
        />
        <circle cx={536.8} cy={363.93} r={17.87} className="cls-5br1" />
        <circle cx={720.32} cy={268.97} r={11.33} className="cls-5br1" />
        <circle cx={1051.44} cy={329.6} r={11.33} className="cls-5br2" />
        <circle cx={936.74} cy={201.79} r={9.59} className="cls-5br1" />
        <circle cx={1182.77} cy={275.48} r={10.87} className="cls-5br1" />
        <circle cx={1325.18} cy={390.22} r={19.04} className="cls-5br1" />
        <circle cx={1499.05} cy={279.32} r={7.04} className="cls-5br1" />
        <circle cx={1583.41} cy={363.93} r={17.87} className="cls-5br4" />
        <circle cx={1481.97} cy={381.8} r={11.33} className="cls-5br2" />
        <circle cx={1325.18} cy={271.99} r={14.36} className="cls-5br3" />
        <circle cx={821.73} cy={371.71} r={10.09} className="cls-5br3" />
        <circle cx={437.97} cy={256.19} r={12.77} className="cls-5br1" />
        {children}
      </g>
    </svg>
  );
}
